var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", [
    _c("label", [_vm._v(_vm._s(_vm.fieldLabel))]),
    _vm._v(" "),
    _c(
      "ul",
      { ref: "list" },
      [
        _vm._l(_vm.selectedOpts, function (entry, idx) {
          return _c(
            "li",
            { key: _vm.fieldLabel + idx },
            [
              _c("multiselect", {
                staticClass: "key",
                attrs: {
                  options: _vm.selectableOptions(idx),
                  "track-by": "key",
                  label: "label",
                  multiple: false,
                  placeholder: _vm.labelSelectPlaceholder,
                  value: _vm.selectedOptions[idx][0],
                },
                on: {
                  change: function (e) {
                    return _vm.optionUpdated(idx, e)
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "val",
                attrs: { type: "text", placeholder: _vm.placeholder(idx) },
                domProps: { value: _vm.filledValues[idx] },
                on: {
                  input: function (e) {
                    return _vm.fieldValueUpdated(idx, e)
                  },
                },
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.selectedOptions.length < _vm.options.length
          ? _c(
              "li",
              { key: _vm.fieldLabel + _vm.selectedOptions.length },
              [
                _c("multiselect", {
                  staticClass: "key",
                  attrs: {
                    options: _vm.selectableOptions(_vm.selectedOptions.length),
                    "track-by": "key",
                    label: "label",
                    placeholder: _vm.labelSelectPlaceholder,
                    multiple: false,
                  },
                  on: {
                    change: function (e) {
                      return _vm.optionUpdated(_vm.selectedOptions.length, e)
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "val",
                  attrs: {
                    type: "text",
                    placeholder: _vm.placeholder(_vm.selectedOptions.length),
                  },
                  on: {
                    input: function (e) {
                      return _vm.fieldValueUpdated(
                        _vm.selectedOptions.length,
                        e
                      )
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }